import { render } from "./CatSubCategory.vue?vue&type=template&id=bade3dfe&lang=html"
import script from "./CatSubCategory.vue?vue&type=script&lang=js"
export * from "./CatSubCategory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__